import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";

// Palette contains in each row the maximum altitude, R,G,B color, and legend text

/*
# QGIS Generated Color Map Export File
INTERPOLATION:DISCRETE
0,0,0,0,0,0
5,255,255,190,255,1-5
25,255,255,115,255,6 - 25
50,255,255,0,255,26 - 50
100,255,170,0,255,51 - 100
500,255,102,0,255,101 - 500
2500,255,0,0,255,501 - 2500
5000,204,0,0,255,2501 - 5000
inf,115,0,0,255,5001 - 185000
*/

const palette = [
  [-1, 180, 180, 180, 255, "N/A"],
  [0, 255, 255, 255, 255, "0"],
  [5, 255, 255, 190, 255, "1 - 5"],
  [25, 255, 255, 115, 255, "6 - 25"],
  [50, 255, 255, 0, 255, "26 - 50"],
  [100, 255, 170, 0, 255, "51 - 100"],
  [500, 255, 102, 0, 255, "101 - 500"],
  [2500, 255, 0, 0, 255, "501 - 2500"],
  [5000, 204, 0, 0, 255, "2501 - 5000"],
  [185000, 115, 0, 0, 255, "5001 - 185000"],
];

export const populationDensityWorldLegendColorList = palette.map(
  ([_val, r, g, b, _a, _txt]) => `rgb(${r}, ${g}, ${b})`,
);

export const PopulationDensityWorldLegend = ({ customLegendStyle = legendStyle }) => {
  const { t } = useTranslation();

  return (
    <div style={customLegendStyle}>
      <div>
        <b>{t("legend.populationDensityWorld")}</b>
      </div>

      {palette.map(([value, r, g, b, a, label]) => (
        <div key={value}>
          <span style={legendItemStyle(`rgba(${r}, ${g}, ${b}, ${a / 255})`)}></span>
          {label}
        </div>
      ))}

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          {t("riskExposureMapExplained.populationDensityWorld")}
        </span>
      </div>
    </div>
  );
};
